
import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome'
import ReactPaginate from 'react-paginate';
import { Box } from 'reactjs-admin-lte'
import ReportStore from '../../stores/ReportStore';
import Select from 'react-select'
import { FormControl, Button,ButtonToolbar,Row,Col,DropdownButton,MenuItem } from 'react-bootstrap'
import { Checkbox } from 'react-icheck'
import IframeModal from 'component/element/IframeModal'
import ReportWorkTable from './ReportWorkTable'
import ConfirmPopup from 'component/element/ConfirmPopup'
import TermOfServiceModal from '../tos/TermOfServiceModal'
import 'icheck/skins/all.css';

const localStorageKey = 'kkc.app.version'
const localStorageAcceptKey = 'ckboss_termofuse_accept'

const printMenuItem1 = [{key:'parkingcar_doc',title:'ใบรับรถเข้าจอดซ่อม',target:'pdf/v2/?startPage=PrintParkingCarDoc'},
{key:'checkingcar_doc_sedan',title:'ใบตรวจสภาพรถก่อนซ่อม (รถเก๋ง)',target:'pdf/?file=checkingcar_doc&car_body_img=carbody3.jpg'},
{key:'checkingcar_doc_pickup',title:'ใบตรวจสภาพรถก่อนซ่อม (รถกระบะ)',target:'pdf/?file=checkingcar_doc&car_body_img=carbody_doublecab.jpg'},
{key:'checkingcar_doc_truck',title:'ใบตรวจสภาพรถก่อนซ่อม (รถบรรทุก)',target:'pdf/?file=checkingcar_doc&car_body_img=carbody_truck.jpg'},
{key:'checkingcar_doc_trailer',title:'ใบตรวจสภาพรถก่อนซ่อม (รถเทรลเลอร์)',target:'pdf/?file=checkingcar_doc&car_body_img=carbody_trailers2.jpg'},
{key:'workqc_doc',title:'ตรวจรับรถก่อนส่งมอบลูกค้า แบบ 1',target:'pdf/v2/?startPage=PrintWorkQCDoc'},
{key:'workqc2_doc',title:'ตรวจรับรถก่อนส่งมอบลูกค้า แบบ 2',target:'pdf/v2/?startPage=PrintKKCWorkQCDoc'},
{key:'receivingcar_doc',title:'เอกสารส่งมอบรถ',target:'pdf/?file=receivingcar_doc'},]

const printMenuItem2 = [{key:'parkingcar_doc',title:'ใบรับรถเข้าจอดซ่อม',target:'pdf/v2/?startPage=PrintParkingCarDoc'},
{key:'checkingdamage_doc',title:'ใบตรวจสอบความเสียหาย',target:'pdf/?file=checkingdamage_doc'},
{key:'checkingcar_doc_carcarrier',title:'ใบตรวจสภาพรถก่อนซ่อม (Car Carrier)',target:'pdf/?file=checkingcar_doc&car_body_img=carbody_carcarrier.jpg'},
{key:'checkingcar_doc_chassis',title:'ใบตรวจสภาพรถก่อนซ่อม (Container Chassis)',target:'pdf/?file=checkingcar_doc&car_body_img=carbody_trailers2.jpg'},
{key:'checkingcar_doc_flatbed',title:'ใบตรวจสภาพรถก่อนซ่อม (Flat Bed)',target:'pdf/?file=checkingcar_doc&car_body_img=carbody_flatbed.jpg'},
{key:'checkingcar_doc_chemicaltank',title:'ใบตรวจสภาพรถก่อนซ่อม (Tanker/Chemical)',target:'pdf/?file=checkingcar_doc&car_body_img=carbody_tanktruck.jpg'},
{key:'checkingcar_doc_cargo',title:'ใบตรวจสภาพรถก่อนซ่อม (Multi Cargo)',target:'pdf/?file=checkingcar_doc&car_body_img=carbody_semitrailers.jpg'},
{key:'checkingcar_doc_dumptruck',title:'ใบตรวจสภาพรถก่อนซ่อม (Dump)',target:'pdf/?file=checkingcar_doc&car_body_img=carbody_dumptruck.jpg'},
{key:'workqc2_doc',title:'ตรวจรับรถก่อนส่งมอบลูกค้า',target:'pdf/v2/?startPage=PrintKKCWorkQCDoc'},
{key:'receivingcar_doc',title:'เอกสารส่งมอบรถ',target:'pdf/?file=receivingcar_doc'},]


class ReportReceptionWork extends Component {

  constructor(...args) {
    super(...args)
    var dt = new Date();
    this.state = {      
      printMenuItem:printMenuItem1,
      loading: false, showDetail: false,showUpgrade:false, filter: 'car_registration_no', year: dt.getFullYear() * 1 + 543, month: "0",
      activePage: 0, itemPerPage: 30,dataCount:0, pageCount: 0, activeMenu: 0, query: '', data: [],checking_by_group:[], showBilling: false 
    }
    //this.onTabClick('all',0)
    this.checkVersion = true     
    // console.log('new render reportWork')
  }

  refreshReport() {
    let { year, month, showDetail, itemPerPage } = this.state
    this.loadReportWork(this.props.apiCall, year, month, showDetail, 0, itemPerPage)
    this.setState({ activePage: 0, activeMenu: 0 })
  }

  componentDidMount(){
    //document.querySelector("meta[property='og:image']").getAttribute("content");
    let { year, month, showDetail, itemPerPage } = this.state
    this.loadReportWork(this.props.apiCall, year, month, showDetail, 0, itemPerPage)
    if(this.props.onRef!==undefined){
      this.props.onRef(this)
    }    
  }

  loadReportWork(apiCall, year, month, showDetail, start, length) {
    
    this.setState({ loading: true })
    let {printMenuItem} = this.state
    // loadReportWork(apiCall, year, month,  showDetail, start, length, q, cat, filter, completeFunc) {
    ReportStore.loadReportWork(apiCall, year, month, showDetail, start, length,'','', {}, (result) => {
      //Laod OK
      
      if(result.print_menu_item!==undefined && result.print_menu_item==='2'){
        printMenuItem = printMenuItem2 
      }
      let column_title = result.column_title.map((item,index)=>{
        item = Object.assign({seq_no:index+1}, item)
        return item
      })
      this.setState({ loading: false,printMenuItem:printMenuItem,checking_by_group:result.checking_by_group, data: result.data,dataCount:result.data_count, pageCount: result.data_count / length,column_index:result.column_index,column_title:column_title  })
    })
  }

  onAcceptClick() {
    localStorage.setItem(localStorageAcceptKey, JSON.stringify({accept:true}))
    this.onUpgradeConfirm()
  }

  onPageChange(apiCall, item) {
    let that = this
    let { itemPerPage, year, month, showDetail } = this.state
    this.setState({ activePage: item.selected })
    this.loadReportWork(apiCall, year, month, showDetail, item.selected * itemPerPage, itemPerPage)
  }

  onTabClick(apiCall, index) {
    this.setState({ activeMenu: index })
    let { year, month, itemPerPage, showDetail } = this.state
    this.loadReportWork(apiCall, year, month, showDetail, 0, itemPerPage)
  }

  onYearChange(apiCall, e) {
    let { month, itemPerPage, showDetail } = this.state
    let year = e.value
    this.setState({ year: year })
    this.loadReportWork(apiCall, year, month, showDetail, 0, itemPerPage)
  }

  onMonthChange(apiCall, e) {
    let { year, itemPerPage, showDetail } = this.state
    let month = e.value
    this.setState({ month: month })
    this.loadReportWork(apiCall, year, month, showDetail, 0, itemPerPage)
  }

  onFilterChange(e) {
    // console.log(e)
    let filter = e ? e.value : ''
    this.setState({ filter: filter })
  }

  onSearchClick() {
    let { query, filter, itemPerPage, showDetail } = this.state
    let that = this
    ReportStore.loadReportReceptionWorkQuery(this.props.apiCall,query, filter, showDetail, function (result) {
      //Laod OK
      that.setState({ data: result.data,dataCount:result.data_count, pageCount: result.data_count / itemPerPage })
    })
  }

  onQueryChange(e) {
    let { filter, itemPerPage } = this.state
    let query = e.target.value
    this.setState({ query: query })

    // if(query.length==0 || query.length==3 || query.length==5){
    //   let that = this
    //   ReportStore.loadReportWorkQuery(query,filter,function(result){
    //   //Laod OK
    //     that.setState({data:result.data,pageCount:result.data_count/itemPerPage})
    //   }) 
    // }
  }

  onShowDetailChange(apiCall, e, showDetail) {
    // console.log('changeDetail', e, showDetail)
    let { year, month, itemPerPage, activePage, query, filter } = this.state
    this.setState({ showDetail: showDetail })
    if (showDetail) {
      if (query !== '') {
        let that = this
        this.setState({ loading: true })
        ReportStore.loadReportWorkQuery(query, filter, showDetail, function (result) {
          //Laod OK
          that.setState({ loading: false, data: result.data,dataCount:result.data_count, pageCount: result.data_count / itemPerPage })
        })
      } else {
        this.loadReportWork(apiCall, year, month, showDetail, activePage * itemPerPage, itemPerPage)
      }
    }
  }

  onSearchKeyPress(target) {
    if (target.charCode == 13) {
      let { query, filter, itemPerPage, showDetail } = this.state
      let that = this
      ReportStore.loadReportWorkQuery(query, filter, showDetail, function (result) {
        //Laod OK
        that.setState({ data: result.data,dataCount:result.data_count, pageCount: result.data_count / itemPerPage })
      })
    }
  }

  onBillingReportClick() {
    //alert('กำลังอยู่ในการพัฒนา');
    this.refs.reportBilling.loadInit()
    this.setState({ showBilling: true })
  }

  onNewWorkClick() {
    if (process.env.NODE_ENV == "development") {
      alert('click new work')
    } else {
      window.show_work_doc('',undefined,'reception')
    }
  }

  onRowWorkClick(workNo,item) {
   
    if (typeof this.props.onRowWorkClick !== 'undefined') 
        this.props.onRowWorkClick(workNo,item)
    else if(typeof window.show_work_doc !=='undefined')
        window.show_work_doc(workNo)
    
  }

  onUpgradeConfirm(){
    localStorage.setItem(localStorageKey, JSON.stringify({version:this.bf_app_version}))
    window.location.reload(true)
    this.setState({showUpgrade:false})
  }

  renderFormSearch() {
    let { filter, query, showDetail } = this.state
    return (
      <form className="navbar-left " style={{ marginLeft: '15px' }}>
        <div className="form-group ">
          <div style={{ width: '180px', display: 'inline-block' }}>
            <Select options={this.getFilterOptions()} value={filter}
              placeholder={'เลือกหมวดในการค้นหา'}
              onChange={this.onFilterChange.bind(this)}
              clearable={false}
            />
          </div>
          <div style={{ width: '280px', display: 'inline-block' }}>
            <div className="input-group ">
              <FormControl
                value={query}
                placeholder="ค้นหาใบงาน..."
                onKeyPress={this.onSearchKeyPress.bind(this)}
                onChange={this.onQueryChange.bind(this)}
              />
              <span className="input-group-btn">
                <Button className='btn-flat' onClick={this.onSearchClick.bind(this)}><FontAwesome name='search' /></Button>

              </span>
            </div>
          </div>
        </div>
      </form>
    )
  }

  getYearOptions() {
    let options = []
    var dt = new Date();
    for (let i = (dt.getFullYear() * 1 + 543); i >= 2558; i--) {
      options.push({ label: i, value: i })
    }
    return options;
  }

  getMonthOptions() {
    return [{ label: 'ทั้งปี', value: '0' },
    { label: 'มกราคม', value: '01' }, { label: 'กุมภาพันธ์', value: '02' },
    { label: 'มีนาคม', value: '03' }, { label: 'เมษายน', value: '04' },
    { label: 'พฤษภาคม', value: '05' }, { label: 'มิถุนายน', value: '06' },
    { label: 'กรกฎาคม', value: '07' }, { label: 'สิงหาคม', value: '08' },
    { label: 'กันยายน', value: '09' }, { label: 'ตุลาคม', value: '10' },
    { label: 'พฤศจิกายน', value: '11' }, { label: 'ธันวาคม', value: '12' },
    ]
  }

  getFilterOptions() {
    return (
      [{ value: 'car_registration_no', label: 'ทะเบียนรถ' }, { value: 'owner_name', label: 'ชื่อลูกค้า' },
      { value: 'owner_tel', label: 'เบอร์โทรศัพท์' }, { value: 'work_no', label: 'เลขรับแจ้ง/ใบงานเลขที่' },
      { value: 'chassis_no', label: 'เลขตัวถัง' }]
    )
  }



  renderCheckbox(apiCall) {
    let { showDetail } = this.state
    return (
      <div style={{ width: '180px', display: 'inline-block', lineHeight: '32px', marginLeft: '15px' }}>
        <Checkbox
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label="แสดงรายละเอียด"
          value={showDetail}
          onChange={this.onShowDetailChange.bind(this, apiCall)}
        />
      </div>

    )
  }

  renderCheckingByGroup(apiCall,index){
    if (apiCall !== 'no_quotation' && apiCall !== 'no_job' && apiCall!=='wait_for_payment') {
      return (<div />)
    }else{
      let {checking_by_group} = this.state
      let len = (checking_by_group.length>0)?checking_by_group.length:1
      let percent = Math.floor(100/len)

      let title = 'จำนวนจ็อบแบ่งตามผู้รับผิดชอบ'
      if(apiCall==='wait_for_payment')
        title = 'จำนวนรายการแบ่งตามตั้งเบิก'
      return (
        <Row>
        <Col md={12}>
          {title}
        </Col>
        <Col md={12}>
        <table className='table table-responsive table-hover table-bordered-solid'>
          <thead>
            <tr>
              {checking_by_group.map((item,index)=>{
              return (<th className='text-center' style={{width:(percent+'%')}}><span>{item.checking_by}</span></th>)
            })}              
            </tr>
          </thead>
          <tbody>
            <tr>
            {checking_by_group.map((item,index)=>{
              return (<td className='text-center'><span>{item.no_of_work}</span></td>)
            })}              
            </tr>
          </tbody>
        </table>
        </Col>
        <br/>

        </Row>
      )
    }
  }

  renderSearch(apiCall, index) {
    if (index !== 0) {
      return (<div />)
    }
    let { month, year } = this.state
    return (
      <Row>
        <div className=" navbar-left" style={{ paddingLeft: '15px' }}>
          <div className="form-group search-record">
            <div style={{ width: '80px', display: 'inline-block' }}>
              <Select value={year} options={this.getYearOptions()}
                onChange={this.onYearChange.bind(this, apiCall)} clearable={false} />
            </div>
            <div style={{ width: '180px', display: 'inline-block' }}>
              <Select
                clearable={false}
                value={month}
                options={this.getMonthOptions()}
                onChange={this.onMonthChange.bind(this, apiCall)}
              />
            </div>
          </div>
        </div>
        {this.renderFormSearch()}
        {this.renderCheckbox(apiCall)}
      </Row>
    )
  }



  renderPaging(apiCall) {

    return (
      <div className="commentBox">
        <ReactPaginate
          previousLabel={"ก่อนหน้า"}
          nextLabel={"ถัดไป"}
          breakLabel={<a href="">...</a>}
          breakClassName={"break-me"}
          pageCount={this.state.pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={2}
          onPageChange={this.onPageChange.bind(this, apiCall)}
          containerClassName={"pagination pull-right"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"} />
      </div>
    )
  }

  onMenuItemSelect(eventKey){
    let url = ''
    
    let item =  this.state.printMenuItem.find((element)=>{
      return (element.key === eventKey)  
    })

    if(item!==null){      
      if (process.env.NODE_ENV == "development") {
        if(item.target.startsWith('pdf/v2')){
          url = './'+item.target.replace('pdf/v2','')
        }else{
          url = 'https://demo2.bigfix.co/korat/'+item.target
        }
      }else{
        url = './'+item.target
      }
      this.refs.iframe.loadUrl(url)
    }else{
      //Nothing
    }

    
  }

  renderPrintDocMenu(){
    
    let title = (<span ><FontAwesome name='print' /> พิมพ์เอกสารเปล่า</span>)

    return (
      
      <ButtonToolbar style={{display:(this.props.showPrintEmptyDoc?"":'none')}}>
        <DropdownButton id='print-empty-doc' bsStyle={'primary'} title={title} pullRight  onSelect={this.onMenuItemSelect.bind(this)}>   
          {this.state.printMenuItem.map((item,index)=>(
            <MenuItem key={index} eventKey={item.key}><FontAwesome name='file-text-o' className='text-green'/>{item.title}</MenuItem>  
          ))}                          
        </DropdownButton>
      </ButtonToolbar>
      
    )
  }

  renderWorkTable(item, index) {
    let { loading, data, showDetail,dataCount,column_index,column_title } = this.state
    return (
      <Box loading={this.state.loading}>
        <Box.Header border={true}>
          <Box.Title>{item.title} {dataCount}  งาน</Box.Title>
          <Box.Tools>            
            {this.renderPrintDocMenu()}
          </Box.Tools>
        </Box.Header>
        <Box.Body>
          {this.props.searchBar && (this.renderSearch(item.apiCall, index))}
          {this.renderCheckingByGroup(item.apiCall,index)}
          <ReportWorkTable rowClass={item.rowClass} data={data} showDetail={showDetail}
            columnIndex={column_index}
            columnTitle={column_title}
          onRowWorkClick={this.onRowWorkClick.bind(this)} />
          {this.renderPaging(item.apiCall)}
        </Box.Body>

      </Box>
    )

  }

  render() {
    let { activeMenu,showUpgrade, showCustomer, showBilling } = this.state
    
    let menu = [{ name: 'ทั้งหมด', className: '', icon: 'files-o', title: this.props.title, apiCall: this.props.apiCall, rowClass: '' },]
    

    return (
      <div className='col-md-12'>
        <div className='nav-tabs-custom'>
          {this.props.addButton && (
          <ul className="nav nav-tabs">
            {menu.map((item, index) => (
              <li key={index} className={(index == activeMenu) ? "active" : ""}>
                <a className={item.className} onClick={this.onTabClick.bind(this, item.apiCall, index)}><FontAwesome name={item.icon} />&nbsp;{item.name}</a>
              </li>
            ))}

            <li className="box-tools pull-right">
              <Button bsStyle='link' className='btn-box-tool text-large'
                onClick={this.onNewWorkClick.bind(this)}
              >
                <FontAwesome name='plus' />&nbsp;เพิ่มใบรับรถ</Button>

            </li>
          </ul>)}
          <div className='tab-content'>
            {
              menu.map((item, index) => (
                <div key={index} className={'tab-pane ' + ((index == activeMenu) ? "active" : "")}>
                  {this.renderWorkTable(item, index)}
                </div>
              ))
            }
          </div>
        </div>
        <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        <ConfirmPopup show={showUpgrade} title='แจ้งเตือน'
          confirmTitle='อับเกรดเวอร์ชั่นใหม่' cancelTitle='ยกเลิก' message='ระบบอู่ซ่อมรถ มีโปรแกรมเวอร์ชั่นใหม่ ต้องการอับเกรดหรือไม่?'
          onConfirm={this.onUpgradeConfirm.bind(this)}
          onHide={() => { this.setState({ showUpgrade: false }) }}
        />
      </div>)
  }
}


ReportReceptionWork.defaultProps = {
  showParkingTab:false,
  showPrintEmptyDoc:false,
  addButton:true,
  searchBar:true,
  title:'ตารางลูกค้าติดต่อทั้งหมด',
  apiCall:'reception_all'
}

export default ReportReceptionWork;





// WEBPACK FOOTER //
// ./src/view/report/ReportReceptionWork.js